import { BasicExtensionFactory, ObjectSelectionHandler, ObjectDeselectionHandler } from "../types/canvasTypes";
import { deselectAll } from "../utils/canvasUtils";

const NAME = "object-selection";

export type DeselectObjectFunction = () => void;
export const createObjectSelectionExtension: BasicExtensionFactory<{
  handleSelection: ObjectSelectionHandler;
  handleDeselection: ObjectDeselectionHandler;
  deselectFunctionFactory: (fn: DeselectObjectFunction) => void;
}> = (options) => {
  const handleSelection: ObjectSelectionHandler = (data) => {
    options?.handleSelection(data);
  };
  const handleDeselection: ObjectDeselectionHandler = (data) => {
    options?.handleDeselection(data);
  };

  return {
    name: NAME,
    onInit: (canvas) => {
      canvas.on("selection:created", handleSelection as any);
      canvas.on("selection:updated", handleSelection as any);
      canvas.on("selection:cleared", handleDeselection as any);

      options.deselectFunctionFactory(() => deselectAll(canvas));
    },
    onDestroy: (canvas) => {
      canvas.off("selection:created", handleSelection as any);
      canvas.off("selection:updated", handleSelection as any);
      canvas.off("selection:cleared", handleDeselection as any);
    },
  };
};
